import request from '@/utils/request'

//首购单商品列表
export function goodsListSGByMember(query) {
    return request({
        url: 'order/goodsListSGByMember',
        method: 'get',
        params: query
    })
}

//首购单验证
export function verificationSG(query) {
    return request({
        url: 'order/verificationSG',
        method: 'get',
        params: query
    })
}

//首购单购买
export function saveSG(data) {
    return request({
        url: 'order/saveSG',
        method: 'post',
        data
    })
}

//首购订单-更新  代办处
export function saveSGA(data) {
    return request({
        url: 'order/saveSGA',
        method: 'post',
        data
    })
}

//注册经销商第一步  代办处/经销商
export function agentRegisterFirst(data) {
    return request({
        url: '/register/agentRegisterFirst',
        method: 'post',
        data
    })
}

//注册经销商第二步  代办处/经销商
export function agentRegisterSecond(data) {
    return request({
        url: '/register/agentRegisterSecond',
        method: 'post',
        data
    })
}
